import { call, put } from 'redux-saga/effects';
import { UserProfileTypes as Types } from '../ducks/userProfile';
import {
  putUserData,
  getUserData,
  putUserPassword,
  putUserAvatar,
  deleteUserAvatar,
  showWelcome,
  postFirstAccess,
  recoverUserPassword,
  checkValidToken,
  putResetPassword,
  getUserAccessProfiles,
} from '../../services/userProfile';
import { errorHandling } from '../../services/api-errors';
import { convertArrToObj } from '../../utils/index';

export function* updateProfile(action) {
  try {
    yield call(putUserData, { name: action.userData.name });
  } catch (error) {
    const errorData = errorHandling(error);
    yield put({ type: Types.UPDATE_PROFILE_FAILURE, errorData });
  }
}

export function* getUserProfile() {
  try {
    const gettingUserData = yield call(getUserData);
    yield put({
      type: Types.SET_USER_PROFILE,
      userData: {
        ...gettingUserData.data,
        avatar: gettingUserData.data.photo,
      },
    });
  } catch (error) {
    const errorData = errorHandling(error);
    yield put({ type: Types.UPDATE_PROFILE_FAILURE, errorData });
  }
}

export function* updatePassword(action) {
  const { newPassword, oldPassword } = action;
  try {
    const updatingPassword = yield call(putUserPassword, {
      newPassword,
      oldPassword,
    });
    yield put({ type: Types.UPDATE_PASSWORD_SUCCESS, ...updatingPassword });
  } catch (error) {
    const errorData = errorHandling(error);
    yield put({ type: Types.UPDATE_PROFILE_FAILURE, errorData });
  }
}

export function* recoverPassword({ email }) {
  if (!email) {
    yield put({ type: Types.RECOVER_USER_PASSWORD_STATUS, emailSent: null });
  } else {
    try {
      yield call(recoverUserPassword, { email });
      yield put({ type: Types.RECOVER_USER_PASSWORD_STATUS, emailSent: true });
    } catch (error) {
      const errorData = errorHandling(error);
      if (errorData.status === 400 || errorData.status === 404) {
        errorData.msg = 'Email não encontrado.';
      }
      yield put({
        type: Types.RECOVER_USER_PASSWORD_STATUS,
        emailSent: errorData,
      });
    }
  }
}

export function* updateAvatar(action) {
  try {
    const updatingAvatar = yield call(putUserAvatar, action.avatar);
    if (updatingAvatar) {
      const gettingUserData = yield call(getUserData);
      yield put({
        type: Types.UPDATE_PROFILE,
        userData: {
          ...gettingUserData.data,
          avatar: gettingUserData.data.photo,
        },
      });
    }
  } catch (error) {
    const errorData = errorHandling(error);
    yield put({ type: Types.UPDATE_PROFILE_FAILURE, errorData });
  }
}

export function* removeAvatar({ fileName }) {
  try {
    const removingAvatar = yield call(deleteUserAvatar, fileName);
    if (removingAvatar) {
      const gettingUserData = yield call(getUserData);
      yield put({
        type: Types.UPDATE_PROFILE,
        userData: {
          ...gettingUserData.data,
          avatar: gettingUserData.data.photo,
        },
      });
    }
  } catch (error) {
    const errorData = errorHandling(error);
    yield put({ type: Types.UPDATE_PROFILE_FAILURE, errorData });
  }
}

export function* clearStatus() {
  yield put({ type: Types.SET_STATUS });
}

export function* getUserFirstAccess() {
  try {
    const checkingFirstAccess = yield call(showWelcome);
    yield put({
      type: Types.SET_FIRST_ACCESS,
      firstAccess: checkingFirstAccess.data,
    });
  } catch (error) {
    errorHandling(error);
  }
}

export function* saveFirstAccessLog(action) {
  try {
    yield call(postFirstAccess);
    yield put({
      type: Types.UPDATE_FIRST_ACCESS,
      firstAccess: action.firstAccess,
    });
  } catch (error) {
    errorHandling(error);
  }
}

export function* canUserResetPassword({ token }) {
  try {
    const checking = yield call(checkValidToken, token);
    const data = yield { email: checking.data };
    yield put({ type: Types.USER_PROFILE_UPDATE, data });
  } catch (error) {
    const errorData = errorHandling(error);
    const data = {
      status: {
        msg:
          errorData.status === 404 || errorData.status === 401
            ? 'Token inválido!'
            : errorData.msg,
        variant: 'error',
      },
    };
    yield put({ type: Types.USER_PROFILE_UPDATE, data });
  }
}

export function* resetUserPassword({ credentials }) {
  try {
    yield call(putResetPassword, credentials);
    const data = {
      status: {
        msg: 'Senha alterada com sucesso!',
        variant: 'success',
      },
    };
    yield put({ type: Types.USER_PROFILE_UPDATE, data });
  } catch (error) {
    const errorData = errorHandling(error);
    const data = {
      status: {
        msg: errorData.msg,
        variant: 'error',
      },
    };
    yield put({ type: Types.USER_PROFILE_UPDATE, data });
  }
}

export function* forceOpenWelcomeModal() {
  yield put({ type: Types.FORCE_FIRST_ACCESS });
}

export function* getAccessProfiles() {
  try {
    const gettingAccessProfiles = yield call(getUserAccessProfiles);
    const accessProfiles = yield {
      list: yield convertArrToObj(gettingAccessProfiles.data, 'id'),
      loaded: true,
    };
    yield put({ type: Types.SET_ACCESS_PROFILES, accessProfiles });
  } catch (error) {
    errorHandling(error);
    yield put({
      type: Types.SET_ACCESS_PROFILES,
      accessProfiles: {
        list: null,
        loaded: true,
      },
    });
  }
}
